module.exports = __webpack_public_path__ + "img/0.024821d8.webp";